import * as React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Colors from "../../utility/Colors";

/**
 * CommonTabs Component
 * @param {Array} tabs - Array of tab objects: [{ label: 'Tab 1', value: '1', content: <Component /> }]
 * @param {String} defaultValue - Default selected tab value
 * @param {Object} sx - Optional styling for the outer Box
 */
export default function CommonTabs({ tabs = [], defaultValue = "1", sx = {} }) {
  const [value, setValue] = React.useState(defaultValue);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%", typography: "body1" }}>
      <TabContext value={value}>
        <Grid spacing={2}>
          <Grid xs={12}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList
                onChange={handleChange}
                aria-label="common tabs"
                variant="scrollable"
                scrollButtons="auto"
              >
                {tabs.map((tab) => (
                  <Tab
                    key={tab.value}
                    label={tab.label}
                    value={tab.value}
                    sx={{
                      textTransform: "none",
                      px: 4,
                      fontWeight: "bold",
                      borderRadius: "5px 5px 0 0 ",
                      border: "1px solid #b3b3b3",
                      borderBottom:
                        value === tab.value
                          ? `3px solid #${Colors.DARK_GREY}`
                          : `3px solid #b3b3b3`,

                      "&.Mui-selected": {
                        color: "#fff",
                        backgroundColor: "primary.main",
                        borderBottom: "2px solid primary.main",
                      },
                      "&:hover": {
                        backgroundColor:
                          value === tab.value ? "primary.dark" : "grey.300",
                      },
                    }}
                  />
                ))}
              </TabList>
            </Box>
          </Grid>
          <Grid xs={12}>
            {tabs.map((tab) => (
              <TabPanel key={tab.value} value={tab.value}>
                {tab.content}
              </TabPanel>
            ))}
          </Grid>
        </Grid>
      </TabContext>
    </Box>
  );
}
